import { MultiDateConstellationField } from '../../../../constellationExtended/MultiDatePicker/MultiDateConstellationField';
import { Label } from '@zillow/constellation';
import React from 'react';
import { useFormikContext } from 'formik';
import { IOrderParams } from '../../../../API/pcDashboard/getOrderAsync';

export const CreationDateFilter: React.FC = () => {
  const {
    initialValues: { createdAtStart, createdAtEnd },
  } = useFormikContext<IOrderParams>();
  return (
    <MultiDateConstellationField
      key={`${createdAtStart}-${createdAtEnd}`}
      startName={'createdAtStart'}
      endName={'createdAtEnd'}
      label={<Label>Creation Date</Label>}
    />
  );
};
